'use strict';

// Vuex
import store from 'store';

// 3rd party
import moment from 'moment';

async function checkTokenTimestamps() {

  if (localStorage.getItem('answerTokenTimestamp')) {
    const timestamp = localStorage.getItem('answerTokenTimestamp');

    if (moment().diff(moment(timestamp), 'minutes') >= 20) {
      store.commit('auth/SET_HEADERS', 'answer');
      const response = await store.dispatch('auth/requestExtendAnswerToken');

      if (response && response.status !== 200) {
        store.dispatch('auth/requestLogout');

        return;
      }
    }
  }

  if (sessionStorage.getItem('fueledAuthTokenTimestamp')) {
    const timestamp = sessionStorage.getItem('fueledAuthTokenTimestamp');

    if (moment().diff(moment(timestamp), 'minutes') > 20) {
      store.commit('auth/SET_HEADERS', 'fueled');
      const response = await store.dispatch('auth/requestExtendToken');

      if (response && response.status !== 200) {
        store.dispatch('auth/requestLogout');

        return;
      }
    }

    if (sessionStorage.getItem('mdLiveAuthTokenTimestamp')) {
      const timestamp = sessionStorage.getItem('mdLiveAuthTokenTimestamp');

      if (moment().diff(moment(timestamp), 'minutes') > 45) {
        store.commit('auth/SET_HEADERS', 'fueled');
        const response = await store.dispatch('auth/requestExtendMdLiveToken');

        if (response && response.status !== 200) {
          store.dispatch('auth/requestLogout');

          return;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }
}

export {
  checkTokenTimestamps,
};



// WEBPACK FOOTER //
// ./client/utils/tokenService.js